export const routes = {
  auth: {
    main: "/auth",
  },
  dashboard: {
    main: "/",
  },
  companies: {
    main: "/companies",
    detail: "/companies/:id",
  },
  jobPositions: {
    main: "/job-positions",
    add: "/job-positions/add",
    edit: "/job-positions/edit/:id",
    view: "/job-positions/:id",
    candidate: "/job-positions/:id/candidate/:assignmentId",
  },
  referral: {
    main: "/referral",
  },
  postHiring: {
    main: "/post-hiring",
    employeeDetails: "/post-hiring/:id",
  },
  financial: {
    main: "/financial",
  },
  support: { main: "/support" },
  talentPool: {
    main: "/talent-pool",
    detail: "/talent-pool/preview/:id",
    fullDetail: "/talent-pool/:id",
    assessmentsPrint: "/talent-pool/:id/assessments/print",
  },

  unauthorized: "/401",
  notFound: "*",
};
